__turbopack_context__.v({
  "heartbeat": "LikeEventButton-module-scss-module__kqNyAa__heartbeat",
  "likeButton": "LikeEventButton-module-scss-module__kqNyAa__likeButton",
  "likeButtonContainer": "LikeEventButton-module-scss-module__kqNyAa__likeButtonContainer",
  "liked": "LikeEventButton-module-scss-module__kqNyAa__liked",
});
